module.exports = __webpack_public_path__ + "static/media/stella_docs.d4cda855.wav";